import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="country-state"
export default class extends Controller {
  static targets = ["country", "stateContainer", "state"]
  static values = {
    statesUrl: String,
    currentState: String
  }

  connect() {
    // Initialize on page load
    this.updateStateField()
  }

  // Called when country selection changes
  countryChanged() {
    this.updateStateField()
  }

  async updateStateField() {
    const country = this.countryTarget.value
    
    // Only show state dropdown for US and Canada
    if (country === "US" || country === "CA") {
      await this.loadStatesDropdown(country)
    } else {
      this.showTextInput()
    }

    // Dispatch event to notify validators that the state field has changed
    this.element.dispatchEvent(new CustomEvent('country-state:fieldChanged', {
      bubbles: true,
      detail: { country: country }
    }));
  }

  async loadStatesDropdown(country) {
    try {
      const response = await fetch(`/states_list/${country}`)
      const states = await response.json()
      
      // Build select element with options
      let selectHtml = `
        <div class="mb-3 form-floating fv-row">
          <select name="order[ship_state]" 
                  id="order_ship_state" 
                  class="form-select"
                  required
                  data-country-state-target="state"
                  data-checkout-address-autocomplete-target="stateInput"
                  aria-label="State"
                  aria-required="true">
            <option value="">-- Select State --</option>
      `
      
      states.forEach(state => {
        const selected = state[1] === this.currentStateValue ? 'selected' : ''
        selectHtml += `<option value="${state[1]}" ${selected}>${state[0]}</option>`
      })
      
      selectHtml += `
          </select>
        <label for="order_ship_state" class="form-label">State</label>
        </div>
      `
      
      this.stateContainerTarget.innerHTML = selectHtml
    } catch (error) {
      console.error('Error loading states:', error)
      this.showTextInput()
    }
  }

  showTextInput() {
    const textHtml = `
      <div class="mb-3">
        <label for="order_ship_state" class="form-label">State/Province</label>
        <input type="text" 
               name="order[ship_state]" 
               id="order_ship_state" 
               placeholder="State/Province" 
               class="form-control"
               required
               data-country-state-target="state"
               data-checkout-address-autocomplete-target="stateInput"
               aria-label="State/Province"
               aria-required="true" />
      </div>
    `
    
    this.stateContainerTarget.innerHTML = textHtml
  }
}
